import React, {useCallback} from 'react';

import CardAd from './cardAd';

import InfinitScroll from 'components/infinitScroll';
import useGetMyPost from './hooks/useGetMyPost';
import EmptyPost from 'assets/images/emptyPage/empty page.svg';
interface BuyAdProps {
  app: 'farm' | 'wholesaler';
  type: 'post';
}
const PostAd = ({app, type}: BuyAdProps) => {
  const {MyPosts, isLoading, fetchNextPage, refetch} = useGetMyPost({
    profile_type: app === 'farm' ? 'farmer' : 'market',
  });
  const MyMyPostsData = MyPosts?.pages.flatMap(x => x.results) || [];

  const onWatchEnd = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);
  return (
    <div className="py-2 flex flex-wrap overflow-visible  justify-center w-full gap-4">
      <InfinitScroll isloading={isLoading} onWatchEnd={onWatchEnd}>
        {MyMyPostsData.length === 0 ? (
          <div className=" mt-28">
            <img src={EmptyPost} alt="empty" className=" block mx-auto" />
            <p className=" text-gray-5 text-center">
              موردی برای نمایش وجود ندارد.
            </p>
          </div>
        ) : (
          MyMyPostsData.map(item => (
            <div key={item.guid} className="flex  w-full justify-center">
              <CardAd
                post={item}
                app={app}
                type={type}
                wrapperClassName="!w-full"
                refetch={refetch}
              />
            </div>
          ))
        )}
      </InfinitScroll>
    </div>
  );
};

export default PostAd;
